import { IEstate, Document, CadastreIdentity } from "../Types/EstateTypes";
import dataApi from "./dataApiSlice";

const estateApi = dataApi.injectEndpoints({
    endpoints: build => ({
        estateData: build.query<IEstate[], string>({
            query: (orgNumber?) => {
                if(orgNumber && orgNumber.length === 9)
                    return `estate/getEstateDataForOrganization/${orgNumber}`;
                return 'estate/getEstateDataForUser';
            }
        }),
        estateDocuments: build.query<Document[], CadastreIdentity>({
            query: (id) => `estate/getDocumentsForEstate/${id.kommunenr}/${id.gardsnr}/${id.bruksnr}/${id.seksjonsnr ?? 0}/${id.festenr ?? 0}`
        }),
        estateGrunnbok: build.query<string, CadastreIdentity>({
            query: (id) => ({
                url: `estate/GetGrunnbokPdf/${id.kommunenr}/${id.gardsnr}/${id.bruksnr}/${id.seksjonsnr ?? 0}/${id.festenr ?? 0}`,
                responseHandler: async (response: Response) => 
                    URL.createObjectURL(await response.blob()),
                cache: 'no-cache',
            })
        })
    })
})

export const { useEstateDataQuery, useEstateDocumentsQuery, useEstateGrunnbokQuery } = estateApi;